import {Employee, EntityType} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {Employees_Read} from "../util/access/Permission";

export const useEmployeeStore = create<EntityStore<Employee[]>>()(
    arrayResource<Employee, EntityStore<Employee[]>>(EntityType.Employees, builder => {
        const rest = builder.crud('/employees', 'id');
        return {
            remoteValue: builder.all(Employees_Read, () => rest.getAll()),
        };
    })
);

startEntityStore(useEmployeeStore);
